import { useNavigate } from 'react-router-dom';
import { useCartStore } from '@/store/cart';
import { useAuth } from '@/contexts/AuthContext';

interface CartButtonProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'floating';
  showBadge?: boolean;
}

export function CartButton({ 
  className = '', 
  size = 'medium', 
  variant = 'default',
  showBadge = true 
}: CartButtonProps) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const itemCount = useCartStore(state => state.getItemCount());

  const handleClick = () => {
    if (!user) {
      navigate('/login');
      return;
    }
    navigate('/cart');
  };

  const sizeClasses = {
    small: 'w-8 h-8 p-1.5',
    medium: 'w-10 h-10 p-2',
    large: 'w-12 h-12 p-2.5'
  };

  const iconSizes = {
    small: '20',
    medium: '24', 
    large: '28'
  };

  const baseClasses = variant === 'floating' 
    ? 'fixed bottom-20 right-6 bg-white shadow-lg border border-gray-200 rounded-full hover:shadow-xl'
    : 'bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200';

  return (
    <button
      onClick={handleClick}
      className={`
        ${baseClasses}
        ${sizeClasses[size]}
        transition-all duration-200 relative
        ${variant === 'floating' ? 'z-[9999]' : ''}
        ${className}
      `}
    >
      <img 
        src="/icons/icon_cart.svg"
        alt="장바구니"
        width={iconSizes[size]}
        height={iconSizes[size]}
        className="object-contain"
      />
      
      {/* 수량 배지 - 로그인 상태에서만 표시 */}
      {showBadge && user && itemCount > 0 && (
        <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
          {itemCount > 99 ? '99+' : itemCount}
        </div>
      )}
    </button>
  );
}